import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import brandImg from "../../Assets/images/pro-img-2.png";
import { useParams } from "react-router-dom";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { Modal } from "react-bootstrap";
import QuotationEditMessage from "../../Modal/QuotationEditMessage";
import QuotationEdit from "../../Modal/QuotationEdit";
import CheckOutModal from "../../Modal/CheckOutModal";
import AddressChangeMessage from "../../Modal/AddressChangeMessage";
import AddressChange from "../../Modal/AddressChange";
import SuccessModal from "../../Modal/SuccessModal";
import Swal from 'sweetalert2'
import { ApiTypes, StorageConstant, VALIDATION_MESSAGE } from '../../constants/Constants'
import NewAddress from "../../Modal/NewAddress";
import { CurrencyConvert, CurrencyConvertHistory, CurrencyIcon, deleteFromStorage, getDate, getFromStorage, getPriceHelper } from "../../utils/Helper";
import { useNavigate } from "react-router-dom";
import Productdelete from "../../Modal/Productdelete";
import ChatModal from "../../Modal/ChatModal";
import QuantityHistory from "../../Modal/QuantityHistory";
import { toast } from "react-toastify";
import { LanguageConstants } from "../../constants/LanguageConstants";
import img1 from "../../Assets/images/pro-img-2.png";
import { socket } from "../../utils/Socket";


function MyquotationView() {
    const { id } = useParams()
    const brandList = useMakeRequest()
    const quotationView = useMakeRequest()
    const quotationDownload = useMakeRequest()
    const quotationReject = useMakeRequest()
    const QuotationUpdate = useMakeRequest()
    const ProductAdd = useMakeRequest()

    const [showMessage, setShowMessage] = useState(false)
    const [editshow, setEditShow] = useState(false)
    const [sendData, setSendData] = useState({})
    const [checkoutShow, setCheckoutShow] = useState(false)
    const [addressMessageShow, setAddressMessageShow] = useState(false)
    const [addressChangeShow, setAddressChangeShow] = useState(false)
    const [paymentshow, setPaymentshow] = useState(false)
    const [newAddress, setNewAddress] = useState(false)
    const [productdelete, setProductDelete] = useState(false)
    const [chatshow, setChatshow] = useState(false)
    const [historyShow, setHistoryShow] = useState(false)
    const [quotesEdit, setQuotesEdit] = useState(false)

    const [historyData, setHistoryData] = useState([])
    const [currency, setCurrency] = useState('USD')
    const [quotes, setQuotes] = useState<any>([])
    const [s_no, setS_no] = useState('')

    const navigate = useNavigate()
    const anotherProduct = getFromStorage({ key: "another_product" });

    useEffect(() => {
        if (id) {
            const payload = {
                quotation_id: id
            }
            quotationView.makeRequest({ payload, url: ApiConstants?.QuotesView, toastStatus: false })
            brandList.makeRequest({ url: ApiConstants?.BrandList, toastStatus: false })
        }
    }, [id, quotationReject?.status, ProductAdd?.status, QuotationUpdate?.status])

    const getTaxValue = (e: any) => {
        if (e?.tax_amount && e?.total_amount) {
            const total = Number(e?.total_shipping_price) + Number(e?.total_product_price) + Number(e?.other_charges)
            const taxValue = (total * e?.tax_amount) / 100;
            return `${taxValue.toFixed(2)}`;
        } else {
            return '0.00';
        }
    };

    // Close message Modal 
    const CloseMessageModal = () => {
        setShowMessage(false)
    }
    // Close Edit product quantity Modal 
    const CloseEditModal = () => {
        setEditShow(false)
    }
    // Close checkOut Modal 
    const CloseCheckOutModal = () => {
        setCheckoutShow(false)
    }
    // Close Address Message Modal 
    const CloseAddressMessageModal = () => {
        setAddressMessageShow(false)
    }
    // clso new Address modal
    const handleClsoNewAddressModal = () => {
        setNewAddress(false)
    }
    // Reject request 
    const handelReject = () => {
        if (anotherProduct != null && anotherProduct?.quotation_id == id) {
            return toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT)
        }
        Swal.fire({
            title: LanguageConstants?.ARE_YOU_SURE,
            text: LanguageConstants?.REJECT_QUTO,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: LanguageConstants?.NO,
            confirmButtonText: LanguageConstants?.YES,
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const payload = {
                    quotation_id: id
                }
                quotationReject.makeRequest({ payload, url: ApiConstants?.QuotesStatusUpdate, toastStatus: true })
            }
        });
    }

    const handelAddProduct = () => {
        if (anotherProduct != null && anotherProduct?.quotation_id == id) {
            return toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT)
        }
        navigate('/create-request-quote', { state: { data: quotationView?.data?.data?.quotation_id, quotes_length: quotationView?.data?.data?.quotes_detail?.length } })
    }
    useEffect(() => {
        if (quotationView?.status) {
            let array: any = []
            quotationView?.data?.data?.quotes_detail?.map((res: any) => (
                array.push({
                    quote_id: res?.id,
                    quantity: res?.quantity,
                    pre_quantity: res?.quantity
                })
            ))
            setQuotes(array)
        }
    }, [quotationView?.status])

    const handelDownloadPdf = () => {
        const payload = {
            quotation_id: id
        }
        quotationDownload.makeRequest({ payload, url: ApiConstants?.QuotesPdf, toastStatus: false })
    }

    const handleDownload = async (url: string) => {
        if (url) {
            // toast.success('Download will start shortly!')
            const response = await fetch(url);
            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', url.split('/').pop() || 'download');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(urlBlob);

        } else {
            toast.success('Something went wrong while trying to download!')
        }

    }

    useEffect(() => {
        if (quotationDownload?.status) {
            if (quotationDownload?.data?.data?.PDF_URL) {
                handleDownload(quotationDownload?.data?.data?.PDF_URL)
                // window.open(quotationDownload?.data?.data?.PDF_URL , '_blacnk')
            }
        }
    }, [quotationDownload?.status])

    const GrandTotal = (e: any) => {
        if (e) {
            const shippingPrice = e?.quantity * e?.per_product_price;
            const total = Number(shippingPrice)
            return total?.toFixed(2)
        }
    }

    const handelUpdate = () => {
        Swal.fire({
            title: LanguageConstants?.ARE_YOU_SURE,
            text: LanguageConstants?.ARE_YOU_SURE_UPDATE,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: 'No',
            confirmButtonText: LanguageConstants?.YES,
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const payload = {
                    quotes: quotes,
                    quotation_id: quotationView?.data?.data?.quotation_id,
                    address_id: quotationView?.data?.data?.address_id
                }
                QuotationUpdate.makeRequest({ payload, url: ApiConstants?.QuotesUpdate, toastStatus: true })
            }
        });
    }

    const handelAddProductON = () => {
        Swal.fire({
            title: LanguageConstants?.ARE_YOU_SURE,
            text: LanguageConstants?.ARE_YOU_SURE_UPDATE,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: 'No',
            confirmButtonText: LanguageConstants?.YES,
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const payload = anotherProduct
                ProductAdd.makeRequest({ payload, url: ApiConstants?.QuotesProductAdd, toastStatus: true })
            } else {
                deleteFromStorage({ key: "another_product", type: 'local' })
                const payload = {
                    quotation_id: id
                }
                quotationView.makeRequest({ payload, url: ApiConstants?.QuotesView, toastStatus: false })
            }
        });
    }

    useEffect(() => {
        if (QuotationUpdate?.status) {
            // navigate('/my-quotation')
            setQuotesEdit(false)
            const payload = {
                sender_type: "1",
                receiver_id: '1'
            }
            socket.emit('admin_count', payload, async (Response: any) => { })
        }
    }, [QuotationUpdate?.status])

    const getBrandName = (id: any) => {
        const name = brandList?.data?.data?.filter((res: any) => res?.id == id)
        return name?.length > 0 ? name[0]?.brands_details?.name : 'N/A'
    }

    const handleCheckout = () => {
        if (anotherProduct != null && anotherProduct?.quotation_id == id) {
            return toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT)
        } else {
            setCheckoutShow(true)
        }
    }

    useEffect(() => {
        if (ProductAdd?.status) {
            deleteFromStorage({ key: "another_product", type: 'local' })
            const payload = {
                sender_type: "1",
                receiver_id: '1'
            }
            socket.emit('admin_count', payload, async (Response: any) => { })
        }
    }, [ProductAdd.status])

    return (
        <>
            {(quotationView?.loading || quotationReject?.loading || quotationDownload.loading || QuotationUpdate.loading || ProductAdd?.loading) ? <FrontLoader /> : null}
            <main>
                <section
                    className="main-banner small-banner"
                    style={{ background: `url(${profileBanner}) center/cover` }}
                >
                    <div className="container">
                        <h1 className="small-banner-heading">{LanguageConstants?.MYOUESTION}</h1>
                        <nav className="com-breadcrumb" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/profile">{LanguageConstants?.PROFILE}</Link></li>
                                <li className="breadcrumb-item"><Link to="/my-quotation">{LanguageConstants?.MYOUESTION}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{LanguageConstants?.VIEW}</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* top banner section end  */}

                <div className="">
                    <div className="container">
                        <div className="quote-ttl-price">
                            <div className="quote-ttl-price-left">
                                {/* <div className="quote-ttl me-3 me-sm-5">Quotation ID :- {quotationView?.data?.data?.quotation_id}</div> */}
                            </div>
                            {quotationView?.data?.data?.status == '0' ?
                                <span className="quote-bnr-tag ms-auto">
                                    <td className="blue-text">
                                        {LanguageConstants?.NEW_PENDING}
                                    </td>
                                </span>
                                : quotationView?.data?.data?.status == '1' ?
                                    <span className="quote-bnr-tag ms-auto">
                                        <td className="yellow-text">
                                            {LanguageConstants?.NEW_Progress}
                                        </td>
                                    </span>
                                    : quotationView?.data?.data?.status == '2' ?
                                        <span className="quote-bnr-tag ms-auto">
                                            <td className="approved-text">
                                                {LanguageConstants?.APPROVED}
                                            </td>
                                        </span>
                                        : <span className="quote-bnr-tag ms-auto">
                                            <td className="red-text">
                                                {LanguageConstants?.REJECT}
                                            </td>

                                        </span>}
                        </div>
                        <div className="quote-card-box">
                            <div className="quote-head">
                                <div>
                                    <label className="quote-label">{LanguageConstants?.QUOTATIONID}</label>
                                    <div className="quote-label-ct">{quotationView?.data?.data?.quotation_id}</div>
                                </div>
                                <div>
                                    <label className="quote-label">{LanguageConstants?.DELADDRESS}</label>
                                    {/* <div className="quote-label-ct">{`${quotationView?.data?.data?.street_line} , ${quotationView?.data?.data?.loaction_type == "1" ? "Residential" : 'Instructions'}`}</div> */}
                                    <div className="quote-label-ct">{`${quotationView?.data?.data?.street_line}`}</div>
                                </div>
                                <div>
                                    <label className="quote-label">{LanguageConstants?.SHIPINNG}</label>
                                    <div className="quote-label-ct">{quotationView?.data?.data?.shipping_Trans_detail?.name} </div>
                                </div>
                                <div>
                                    <label className="quote-label">{LanguageConstants?.QDATE}</label>
                                    <div className="quote-label-ct">{getDate(quotationView?.data?.data?.created_at)}</div>
                                </div>
                                <div className="quote-head-btns">
                                    {quotationView?.data?.data?.status == '1' || quotationView?.data?.data?.status == '2' ?
                                        <button className="chat-open-btn" onClick={() => handelDownloadPdf()} ><span className="chat-btn-icon"><i className="icon-download"></i></span><span>{LanguageConstants?.DOWNLOAD_PDF}</span></button>
                                        : null}
                                    {((quotationView?.data?.data?.status == '1' || quotationView?.data?.data?.status == '0')) ?
                                        <button className="add-pro-btn" onClick={() => handelAddProduct()} >
                                            <i className="add-pro-plus-icon icon-add-circle"></i>
                                            <span>{LanguageConstants?.ADDMOREPRODUCT}</span>
                                            <span className="add-pro-btn-circle"><i className="icon-chev-right"></i></span>
                                        </button>
                                        : null}
                                </div>
                            </div>
                            <div className="card-box mb-5 mt-3">
                                <div className="table-responsive com-table rqst-table rqst-table-view">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="text-center">{LanguageConstants?.Item}</th>
                                                <th className="text-center">{LanguageConstants?.ORDER_QTY}</th>
                                                <th className="text-center">{LanguageConstants?.BRAND}</th>
                                                <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                                                <th className="text-center">{LanguageConstants?.Description}</th>
                                                <th className="text-center">{LanguageConstants?.SERIALNUMBER}</th>
                                                <th className="text-center">{LanguageConstants?.MODELNUMBER}</th>
                                                <th className="text-center">{LanguageConstants?.PRE_PRODUCT_PRICE}</th>
                                                <th className="text-center">{LanguageConstants?.EXTED_PRICE}</th>
                                                <th className="text-center">ETA</th>
                                                <th className="text-center">{LanguageConstants?.ACTION}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {quotationView?.data?.data?.quotes_detail?.map((res: any, i: any) => (

                                                <tr>
                                                    <td className="text-center">{i + 1} <br /> </td>
                                                    <td className="text-center">{res?.new_quantity ? res?.new_quantity : res?.quantity} <br /> </td>
                                                    {res?.is_other_brand == "1" ?
                                                        <td className="text-center"> {res?.other_brand_name}</td>
                                                        :
                                                        <td className="text-center">{res?.brand_detail?.name}</td>
                                                    }
                                                    <td className="text-center">{res?.part_number}</td>
                                                    {res?.description ? <td className="text-center">{res?.description}</td> : <td className="text-center">N/A</td>}
                                                    {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>}
                                                    {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>}
                                                    <td className="text-center">{CurrencyIcon(currency)}{(quotationView?.data?.data?.status != 0 && res?.per_product_price) ? getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                                                    {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                                                    <td className="text-center"> {CurrencyIcon(currency)}{(quotationView?.data?.data?.status != 0 && res?.eta_day) ? getPriceHelper(CurrencyConvertHistory(GrandTotal(res), currency)) : '0.00'} </td>
                                                    <td className="text-center">{(quotationView?.data?.data?.status != 0 && res?.eta_day) ? res?.eta_day : 'N/A'}</td>
                                                    <td className="text-center">
                                                        {quotationView?.data?.data?.status == '1' || quotationView?.data?.data?.status == '0' ?
                                                            <>
                                                                <div className="single-brand-action-wrap justify-content-center">
                                                                    {anotherProduct?.quotation_id == id ?
                                                                        <button className="single-brand-action" onClick={() => { toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT) }} ><i className="icon-edit-profile"></i></button>
                                                                        :
                                                                        <button className="single-brand-action" onClick={() => { setEditShow(true); setSendData(res); setS_no(i + 1) }} ><i className="icon-edit-profile"></i></button>
                                                                    }
                                                                    {anotherProduct?.quotation_id == id ?

                                                                        <button className="single-brand-action" onClick={() => { toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT) }}  ><i className="icon-delete"></i></button>
                                                                        :
                                                                        <button className="single-brand-action" onClick={() => { setProductDelete(!productdelete); setSendData(res); setS_no(i + 1) }}  ><i className="icon-delete"></i></button>
                                                                    }

                                                                </div>
                                                            </>
                                                            : null}
                                                    </td>
                                                </tr>
                                            ))}

                                            {anotherProduct?.quotation_id == id && anotherProduct?.quotes?.map((res: any, i: any) => (

                                                <tr>
                                                    <td className="text-center">{quotationView?.data?.data?.quotes_detail?.length + i + 1} <br /> </td>
                                                    <td className="text-center">{res?.new_quantity ? res?.new_quantity : res?.quantity} <br /> </td>
                                                    <td className="text-center"> {res?.is_other_brand == '1' ? res?.other_brand_name : getBrandName(res?.brand_id)}</td>
                                                    <td className="text-center">{res?.part_number}</td>
                                                    {res?.description ? <td className="text-center">{res?.description}</td> : <td className="text-center">N/A</td>}
                                                    {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>}
                                                    {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>}
                                                    <td className="text-center">{CurrencyIcon(currency)}{(quotationView?.data?.data?.status != 0 && res?.per_product_price) ? getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                                                    {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                                                    <td className="text-center"> {CurrencyIcon(currency)}{(quotationView?.data?.data?.status != 0 && res?.eta_day) ? getPriceHelper(CurrencyConvertHistory(GrandTotal(res), currency)) : '0.00'} </td>
                                                    <td className="text-center">{(quotationView?.data?.data?.status != 0 && res?.eta_day) ? res?.eta_day : 'N/A'}</td>
                                                    <td className="text-center">
                                                        {quotationView?.data?.data?.status == '1' || quotationView?.data?.data?.status == '0' ?
                                                            <>
                                                                <div className="single-brand-action-wrap justify-content-center">
                                                                    <button className="single-brand-action" disabled ><i className="icon-edit-profile"></i></button>
                                                                    <button className="single-brand-action" disabled ><i className="icon-delete"></i></button>
                                                                </div>
                                                            </>
                                                            : null}
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                                {(quotationView?.data?.data?.status == '1' || quotationView?.data?.data?.status == '0') && (quotesEdit) ?
                                    <button className="com-btn cursor-pointer head-quote-btn" onClick={() => handelUpdate()} style={{ marginTop: "10px" }} >{LanguageConstants?.EDITQUANTITY}</button>
                                    : null}
                                {anotherProduct?.quotes?.length > 0 && anotherProduct?.quotation_id == id ?
                                    <button className="com-btn cursor-pointer head-quote-btn" onClick={() => handelAddProductON()} style={{ marginTop: "10px" }} >{LanguageConstants?.CONFIRMA}</button>
                                    : null}
                            </div>
                            <div className="card-box mb-5 mt-3">
                                <div className="row">
                                    {(quotationView?.data?.data?.total_amount && quotationView?.data?.data?.status != 0) ?
                                        <div className="col-md-6 quote-mid-col py-0 border-0">
                                            <div className="provide-quotation-wrap">
                                                <div className="quote-mid">
                                                    <h3 className="quote-ttl">{LanguageConstants?.PROVIDEDQUOTATION}</h3>
                                                    <div className="table-responsive ">
                                                        <table className="table">
                                                            <tbody>
                                                                <tr>
                                                                    <td>{LanguageConstants?.TOTALPRODUCTAMOUNT}</td>
                                                                    <th>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(quotationView?.data?.data?.total_product_price, currency))} </th>
                                                                </tr>
                                                                <tr>
                                                                    <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                                                    <th>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(quotationView?.data?.data?.total_shipping_price, currency))} </th>
                                                                </tr>
                                                                <tr>
                                                                    <td>{LanguageConstants?.OTHER} {LanguageConstants?.CHARGES}</td>
                                                                    {/* {quotationView?.data?.data?.charges_reason ? 
                                                    <td>{quotationView?.data?.data?.charges_reason}</td>
                                                    :null} */}
                                                                    <th> {CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(quotationView?.data?.data?.other_charges, currency))} </th>
                                                                </tr>
                                                                {quotationView?.data?.data?.charges_reason ?
                                                                    <tr>
                                                                        <td>{LanguageConstants?.Charges_reason}</td>
                                                                        <th>{quotationView?.data?.data?.charges_reason}</th>
                                                                    </tr>
                                                                    : null}
                                                                <tr>
                                                                    <td>{LanguageConstants?.TOTALTAX}</td>
                                                                    <th>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(getTaxValue(quotationView?.data?.data), currency))} </th>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td className="fw-bold">{LanguageConstants?.GRANDTOTAL}</td>
                                                                    <td className="text-end fw-bold">{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(quotationView?.data?.data?.total_amount, currency))} </td>
                                                                </tr>
                                                                <p style={{ color: 'red' }}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="quote-foot">
                                                    <div className="form-check form-switch w-100">
                                                        <label className="form-check-label">{LanguageConstants?.CONVERTINPISO}</label>
                                                        <input className="form-check-input" type="checkbox" onClick={() => setCurrency(currency == "PHP" ? "USD" : 'PHP')} />
                                                    </div>
                                                </div>
                                                {quotationView?.data?.data?.status == '1' ?
                                                    <div className="quote-foot-btns">

                                                        <button className="reject-approve-btn reject" onClick={() => handelReject()}  >{LanguageConstants?.Reject}</button>
                                                        <button className="reject-approve-btn" onClick={() => handleCheckout()} >{LanguageConstants?.Approve}</button>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* edit message modal start */}
            <Modal show={showMessage}>
                <QuotationEditMessage handleClose={CloseMessageModal} data={sendData} setEditShow={setEditShow} quotes={quotes} />
            </Modal>
            {/* edit message modal end */}


            {/* edit  modal start */}
            <Modal show={editshow}>
                <QuotationEdit s_no={s_no} handleClose={CloseEditModal} data={sendData} setQuotesEdit={setQuotesEdit} setQuotes={setQuotes} quotes={quotes} />
            </Modal>
            {/* edit  modal end */}

            {/* Check Out Modal start */}
            <Modal show={checkoutShow}>
                <CheckOutModal handleClose={CloseCheckOutModal} data={quotationView?.data?.data} setAddressMessageShow={setAddressMessageShow} setPaymentshow={setPaymentshow} />
            </Modal>
            {/* Check Out Modal End */}


            {/* Address change message start */}
            <Modal show={addressMessageShow}>
                <AddressChangeMessage handleClose={CloseAddressMessageModal} setAddressChangeShow={setAddressChangeShow} />
            </Modal>
            {/* Address change message End */}


            {/* Address change  start */}
            <Modal show={addressChangeShow}  >
                <AddressChange setAddressChangeShow={setAddressChangeShow} data={quotationView?.data?.data} setNewAddress={setNewAddress} />
            </Modal>
            {/* Address change  End */}


            {/* Paymnet success   start */}
            <Modal show={paymentshow}  >
                <SuccessModal />
            </Modal>
            {/* Paymnet success  End */}

            {/* Add new address  start */}
            <Modal show={newAddress}  >
                <NewAddress handleClose={handleClsoNewAddressModal} data={quotationView?.data?.data} />
            </Modal>
            {/* Add new address  End */}

            {/* Product delte start */}
            <Modal show={productdelete}  >
                <Productdelete s_no={s_no} setProductDelete={setProductDelete} data={sendData} />
            </Modal>
            {/* Product delte end */}


            {/* Chat Modal  start */}
            <Modal show={chatshow} >
                <ChatModal data={quotationView?.data?.data} setChatshow={setChatshow} />
            </Modal>
            {/* Chat Modal  end */}

            {/* // open Quantity History Modal start */}
            <Modal show={historyShow} >
                <QuantityHistory data={historyData} setHistoryShow={setHistoryShow} />
            </Modal>
            {/* // open Quantity History Modal end */}

        </>
    )
}

export default MyquotationView